class ElikmedSubcollections extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.elikmed-subcollections__track');
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }
    }, options);

  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  move(direction) {
    const card = this.track.firstElementChild;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
    const rtl = getComputedStyle(this.track).direction === 'rtl';
    this.track.scrollBy({
      left: step * direction * (rtl ? -1 : 1),
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  }

}

if (!customElements.get('elikmed-subcollections')) {
  customElements.define('elikmed-subcollections', ElikmedSubcollections);
}
